module.exports = __webpack_public_path__ + "img/news-1.80210a6c.png";